import { TechniqueFull } from '@omniafishing/core';
import React from 'react';
import { useFrontload } from 'react-frontload';
import { useSelector } from 'react-redux';
import { ScrollToTop } from '../../components/scroll_to_top/scroll_to_top';
import { apiV1 } from '../../lib/api';
import { getIp } from '../../redux/geographic_location';
import { getCategories, getSubcategories } from '../../redux/reference_data';
import { StyleKeywordDetail } from './style_keyword';

interface StyleKeywordPageProps {
  style: TechniqueFull;
  slug: string;
}
export const StyleKeywordPage = (props: StyleKeywordPageProps) => {
  const { slug, style } = props;

  const categories = useSelector(getCategories);
  const subcategories = useSelector(getSubcategories);
  const ip_address = useSelector(getIp);

  const { frontloadMeta, data } = useFrontload(`StyleKeywordPage:${slug}`, async () => {
    const styleKeywordResponse = await apiV1.techniqueKeywordFetch(slug, ip_address);
    const styleKeywordsResponse = await apiV1.techniqueKeywordsFetch({
      category: styleKeywordResponse.data.data.technique_keyword.category,
    });

    return {
      style_keyword: styleKeywordResponse.data.data.technique_keyword,
      style_keywords: styleKeywordsResponse.data.data,
      top_reported: styleKeywordResponse.data.data.top_reported,
    };
  });

  if (frontloadMeta.pending) {
    return null;
  }

  const { style_keyword, style_keywords, top_reported } = data;
  const category = categories.find((c) => c.name === style_keyword.category);
  const subcategory = subcategories.find((s) => s.name === style_keyword.subcategory);

  return (
    <ScrollToTop>
      <StyleKeywordDetail
        category={category}
        subcategory={subcategory}
        style={style}
        styleKeyword={style_keyword}
        styleKeywords={style_keywords.filter((sk) => sk.slug !== style_keyword.slug)}
        topReported={top_reported}
      />
    </ScrollToTop>
  );
};

export default StyleKeywordPage;
